function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import get from 'lodash/get';
import map from 'lodash/map';
import { getDays, getDaysInMonth, getMonths, getYears } from 'helpers/datetime';
import FormGroup from 'components/Form/FormGroup';
import CompoundInput from 'components/Form/CompoundInput';
import Select from 'components/Form/Select';
import App from 'modules/App';
var _React_PureComponent;
class DateOfBirthFormPartial extends (_React_PureComponent = React.PureComponent) {
    onSetDateOfBirth(input) {
        const { value } = input;
        const daysInMonth = getDaysInMonth(value.month, value.year);
        if (daysInMonth < value.day) {
            input.value.day = '';
        }
        this.props.onSetFormValue(input);
    }
    render() {
        const birthMonth = get(this.props.formValues, 'values.dateOfBirth.month');
        const birthYear = get(this.props.formValues, 'values.dateOfBirth.year');
        const momentDate = moment().month(0);
        if (birthYear) {
            momentDate.year(birthYear);
        }
        if (birthMonth) {
            momentDate.month(birthMonth - 1);
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "dateOfBirth",
            labelMessage: App.messages.labels.dateOfBirth,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsxs(CompoundInput, {
                onChange: (input)=>this.onSetDateOfBirth(input),
                children: [
                    /*#__PURE__*/ _jsx(Select, {
                        id: "day",
                        optionsFrom: map(getDays(birthMonth, birthYear), (day)=>({
                                day,
                                label: momentDate.date(day).format('D')
                            })),
                        valueKey: "day",
                        labelKey: "label",
                        noValueMessage: App.messages.placeholders.day,
                        isDisabled: this.props.isDisabled,
                        containerClassName: "col-3"
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        id: "month",
                        optionsFrom: map(getMonths(), (month, idx)=>({
                                value: idx + 1,
                                label: month
                            })),
                        valueKey: "value",
                        labelKey: "label",
                        noValueMessage: App.messages.placeholders.month,
                        isDisabled: this.props.isDisabled,
                        containerClassName: "col-6"
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        id: "year",
                        optionsFrom: map(getYears(), (year)=>({
                                year,
                                label: moment().year(year).format('YYYY')
                            })),
                        valueKey: "year",
                        labelKey: "label",
                        noValueMessage: App.messages.placeholders.year,
                        isDisabled: this.props.isDisabled,
                        containerClassName: "col-3"
                    })
                ]
            })
        });
    }
}
_define_property(DateOfBirthFormPartial, "propTypes", {
    // Explicit props
    formValues: PropTypes.object,
    isDisabled: PropTypes.bool,
    // Explicit actions
    onSetFormValue: PropTypes.func
});
export default DateOfBirthFormPartial;
